var levelOfAWSUsage = {
	"Level of AWS usage": "Livello di utilizzo di AWS",
	"Do not use AWS today": "Non utilizza AWS al momento",
	"Evaluating/experimenting with AWS": "Valutazione/sperimentazione con AWS in corso",
	"Run dev/test workloads on AWS": "Esecuzione di carichi di lavoro di sviluppo/test su AWS",
	"Run a production workload on AWS": "Esecuzione di un singolo carico di lavoro di produzione su AWS",
	"Run multiple production workloads on AWS": "Esecuzione di piÃ¹ carichi di lavoro di produzione in AWS"
};

export { levelOfAWSUsage as default };
